// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("./MM_parser.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");

function getExprFromNode(node) {
  if (node.TAG === /* Hypothesis */0) {
    return node.expr;
  } else {
    return node.expr;
  }
}

function compareSubArrays(src, srcFromIdx, dst, dstFromIdx, len) {
  var s = srcFromIdx;
  var d = dstFromIdx;
  var srcLen = src.length;
  var dstLen = dst.length;
  if (srcLen < (srcFromIdx + len | 0) || dstLen < (dstFromIdx + len | 0)) {
    return false;
  }
  var sMax = (srcFromIdx + len | 0) - 1 | 0;
  while(s <= sMax && Caml_obj.equal(Caml_array.get(src, s), Caml_array.get(dst, d))) {
    d = d + 1 | 0;
    s = s + 1 | 0;
  };
  return s > sMax;
}

function compareExprAfterSubstitution(expr, subs, eqTo) {
  var e = 0;
  var t = 0;
  var eq = true;
  var eLen = expr.length;
  var tLen = eqTo.length;
  while(eq && e < eLen && t < tLen) {
    var s = Caml_array.get(expr, e);
    if (s < 0) {
      eq = s === Caml_array.get(eqTo, t);
      t = t + 1 | 0;
    } else {
      var subExpr = Caml_array.get(subs, s);
      var len = subExpr.length - 1 | 0;
      eq = compareSubArrays(subExpr, 1, eqTo, t, len);
      t = t + len | 0;
    }
    e = e + 1 | 0;
  };
  if (eq && e === eLen) {
    return t === tLen;
  } else {
    return false;
  }
}

function applySubs(expr, subs) {
  var resultSize = {
    contents: 0
  };
  expr.forEach(function (s) {
        if (s < 0) {
          resultSize.contents = resultSize.contents + 1 | 0;
        } else {
          resultSize.contents = (resultSize.contents + Caml_array.get(subs, s).length | 0) - 1 | 0;
        }
      });
  var res = new Array(resultSize.contents);
  var e = 0;
  var r = 0;
  while(r < resultSize.contents) {
    var s = Caml_array.get(expr, e);
    if (s < 0) {
      Caml_array.set(res, r, s);
      r = r + 1 | 0;
    } else {
      var subExpr = Caml_array.get(subs, s);
      var len = subExpr.length - 1 | 0;
      Expln_utils_common.copySubArray(subExpr, 1, res, r, len);
      r = r + len | 0;
    }
    e = e + 1 | 0;
  };
  return res;
}

function extractSubstitution(stack, stackLength, frame) {
  var subs = new Array(frame.numOfVars);
  var subsLock = Belt_Array.make(frame.numOfVars, false);
  var baseIdx = stackLength - frame.numOfArgs | 0;
  frame.hyps.forEach(function (hyp, i) {
        if (hyp.typ !== /* F */0) {
          return ;
        }
        var t = Caml_array.get(hyp.expr, 0);
        var v = Caml_array.get(hyp.expr, 1);
        if (Caml_array.get(subsLock, v)) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "subsLock[v]"
                },
                Error: new Error()
              };
        }
        var subsExpr = getExprFromNode(Caml_array.get(stack, baseIdx + i | 0));
        if (subsExpr.length < 2) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "subsExpr->Js_array2.length < 2"
                },
                Error: new Error()
              };
        }
        if (Caml_array.get(subsExpr, 0) !== t) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "subsExpr[0] != t"
                },
                Error: new Error()
              };
        }
        Caml_array.set(subsLock, v, true);
        Caml_array.set(subs, v, subsExpr);
      });
  if (subsLock.some(function (lock) {
          return !lock;
        })) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "subsLock->Js_array2.some(lock => !lock)"
          },
          Error: new Error()
        };
  }
  return subs;
}

function validateTopOfStackMatchesFrame(stack, stackLength, frame, subs) {
  var baseIdx = stackLength - frame.numOfArgs | 0;
  frame.hyps.forEach(function (hyp, i) {
        if (!(hyp.typ === /* E */1 && !compareExprAfterSubstitution(hyp.expr, subs, getExprFromNode(Caml_array.get(stack, baseIdx + i | 0))))) {
          return ;
        }
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "!compareExprAfterSubstitution(ess, subs, stack->getExprFromStack(baseIdx+i))"
              },
              Error: new Error()
            };
      });
}

var zCode = Belt_Option.getExn("Z".codePointAt(0));

var aCode = Belt_Option.getExn("A".codePointAt(0));

var aCodePrev = aCode - 1 | 0;

var tCode = Belt_Option.getExn("T".codePointAt(0));

var uCode = Belt_Option.getExn("U".codePointAt(0));

var uCodePrev = uCode - 1 | 0;

function compressedProofBlockToArray(str) {
  var len = str.length;
  var res = [];
  var b = 0;
  var e = 0;
  while(e < len) {
    var c = Belt_Option.getExn(str.codePointAt(e));
    if (c === zCode) {
      res.push("Z");
      e = e + 1 | 0;
      b = e;
    } else if (aCode <= c && c <= tCode) {
      res.push(str.substring(b, e + 1 | 0));
      e = e + 1 | 0;
      b = e;
    } else {
      e = e + 1 | 0;
    }
  };
  return res;
}

function compressedProofCharCodeToInt(code) {
  if (code <= tCode) {
    return code - aCodePrev | 0;
  } else {
    return code - uCodePrev | 0;
  }
}

function compressedProofStrToInt(str) {
  var res = 0;
  var base = 1;
  var len = str.length;
  for(var i = len - 2 | 0; i >= 0; --i){
    res = res + Math.imul(base, compressedProofCharCodeToInt(Belt_Option.getExn(str.codePointAt(i)))) | 0;
    base = Math.imul(base, 5);
  }
  return Math.imul(res, 20) + compressedProofCharCodeToInt(Belt_Option.getExn(str.codePointAt(len - 1 | 0))) | 0;
}

function intToCompressedProofStr(i) {
  if (i < 1) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "intToCompressedProofStr: i < 1"
          },
          Error: new Error()
        };
  }
  var res = [String.fromCharCode(aCode + (i - 1 | 0) % 20 | 0)];
  var i$1 = (i - 1 | 0) / 20 | 0;
  while(i$1 > 0) {
    res.push(String.fromCharCode(uCode + (i$1 - 1 | 0) % 5 | 0));
    i$1 = (i$1 - 1 | 0) / 5 | 0;
  };
  return res.reverse().join("");
}

function applyAsrt(stack, frame) {
  var stackLength = stack.length;
  if (stackLength < frame.numOfArgs) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "stackLength < numOfArgs"
          },
          Error: new Error()
        };
  }
  var subs = extractSubstitution(stack, stackLength, frame);
  validateTopOfStackMatchesFrame(stack, stackLength, frame, subs);
  var newNode_0 = stack.slice(stackLength - frame.numOfArgs | 0);
  var newNode_1 = frame.label;
  var newNode_2 = applySubs(frame.asrt, subs);
  var newNode = {
    TAG: /* Calculated */1,
    args: newNode_0,
    asrtLabel: newNode_1,
    expr: newNode_2
  };
  for(var _for = 1 ,_for_finish = frame.numOfArgs; _for <= _for_finish; ++_for){
    stack.pop();
  }
  stack.push(newNode);
}

function applyUncompressedProof(ctx, stack, proofLabels) {
  proofLabels.forEach(function (step) {
        var hyp = MM_context.getHypothesis(ctx, step);
        if (hyp !== undefined) {
          stack.push({
                TAG: /* Hypothesis */0,
                hypLabel: hyp.label,
                expr: hyp.expr
              });
          return ;
        }
        var frame = MM_context.getFrame(ctx, step);
        if (frame !== undefined) {
          return applyAsrt(stack, frame);
        }
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "The proof step '" + step + "' doesn't refer to a hypothesis or assertion (in uncompressed proof)."
              },
              Error: new Error()
            };
      });
}

function applyCompressedProof(ctx, expr, stack, labels, compressedProofBlock) {
  var steps = compressedProofBlockToArray(compressedProofBlock);
  var hyps = MM_context.getMandHyps(ctx, expr);
  var hypLen = hyps.length;
  var hypLenPlusLabelsLen = hypLen + labels.length | 0;
  var savedNodes = [];
  Belt_Array.forEach(steps, (function (step) {
          if (step === "Z") {
            var stackLen = stack.length;
            if (stackLen === 0) {
              throw {
                    RE_EXN_ID: MM_parser.MmException,
                    _1: {
                      msg: "Cannot execute 'Z' command because the stack is empty."
                    },
                    Error: new Error()
                  };
            }
            savedNodes.push(Caml_array.get(stack, stackLen - 1 | 0));
            return ;
          }
          var i = compressedProofStrToInt(step);
          if (i < 1) {
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "Unexpected condition when applying compressed proof: i < 1."
                  },
                  Error: new Error()
                };
          }
          if (i <= hypLen) {
            var hyp = Caml_array.get(hyps, i - 1 | 0);
            stack.push({
                  TAG: /* Hypothesis */0,
                  hypLabel: hyp.label,
                  expr: hyp.expr
                });
            return ;
          }
          if (i <= hypLenPlusLabelsLen) {
            var labelToApply = Caml_array.get(labels, (i - hypLen | 0) - 1 | 0);
            var hyp$1 = MM_context.getHypothesis(ctx, labelToApply);
            if (hyp$1 !== undefined) {
              stack.push({
                    TAG: /* Hypothesis */0,
                    hypLabel: hyp$1.label,
                    expr: hyp$1.expr
                  });
              return ;
            }
            var frame = MM_context.getFrame(ctx, labelToApply);
            if (frame !== undefined) {
              return applyAsrt(stack, frame);
            }
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "The proof step '" + labelToApply + "' doesn't refer to a hypothesis or assertion (in compressed proof)."
                  },
                  Error: new Error()
                };
          }
          var node = Belt_Array.get(savedNodes, (i - hypLenPlusLabelsLen | 0) - 1 | 0);
          if (node !== undefined) {
            stack.push(node);
            return ;
          }
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Compressed proof refers to a saved step by the index which is out of bounds."
                },
                Error: new Error()
              };
        }));
}

function verifyProof(ctx, expr, proof) {
  var stack = [];
  if (proof.TAG === /* Uncompressed */0) {
    applyUncompressedProof(ctx, stack, proof.labels);
  } else {
    applyCompressedProof(ctx, expr, stack, proof.labels, proof.compressedProofBlock);
  }
  if (stack.length !== 1) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "stack->Js_array2.length is " + String(stack.length) + " but must be 1."
          },
          Error: new Error()
        };
  }
  if (Caml_obj.notequal(getExprFromNode(Caml_array.get(stack, 0)), expr)) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "stack[0] != expr" + ("\nstack[0] is '" + MM_context.ctxIntsToStrExn(ctx, getExprFromNode(Caml_array.get(stack, 0))) + "'") + ("\nexpr is     '" + MM_context.ctxIntsToStrExn(ctx, expr) + "'")
          },
          Error: new Error()
        };
  }
  return Caml_array.get(stack, 0);
}

exports.verifyProof = verifyProof;
exports.getExprFromNode = getExprFromNode;
exports.compressedProofBlockToArray = compressedProofBlockToArray;
exports.compressedProofStrToInt = compressedProofStrToInt;
exports.intToCompressedProofStr = intToCompressedProofStr;
/* zCode Not a pure module */
